import { useMutation, useQueryClient } from '@tanstack/react-query';

import UsersService from '~/services/UsersService';

import { usersQueryKeys } from './usersQueryKeys';

type CreateAccountIdentityPayload = {
  identity_provider_id: string;
  identifier_claim_value: string;
};

export function useCreateAccountIdentity(accountId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateAccountIdentityPayload) => UsersService.createAccountIdentity(accountId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: usersQueryKeys.accountIdentityList(accountId) });
    },
  });
}
